import React from "react";

export default function ProficiencyLevels_EN() {
  return (
    <>
      <h2>Proficiency levels explained</h2>
      <div>
        To better understand your personal competence profile, you should look at your performance by
        area. It should give you a first idea that can help you determine your relative weaknesses and
        strengths, while providing you with suggestions and ideas to further develop your digital
        practices.
        <ul>
          <li>A1: up to 32/192 points, up to 17%</li>
          <li>A2: 33-64/192 points, 18-33%</li>
          <li>B1: 65-96/192 points 34-50%</li>
          <li>B2: 97-128/192 points, 51-67%</li>
          <li>C1: 129-160/192 points, 68-83%</li>
          <li>C2: 161-192/192 points 84-100%</li>
          <li>D1: 0/192 points, 0%</li>
        </ul>
      </div>
      <div>
        <h3> Newcomer (A1)</h3>
        <div style={{ marginBottom: "20px" }}>
          You are aware of how digital technologies can support and enhance your professional practice.
          The feedback you get from this self-reflection has identified a number of actions you can try.
          Select one or two to plan your next learning pathway, focusing on meaningfully enhancing your
          teaching strategies. As you do so, you’ll find yourself moving to the next step of digital
          competence, the Explorer level.
        </div>
      </div>
      <div>
        <h3> Explorer (A2)</h3>
        <div style={{ marginBottom: "20px" }}>
          You have started exploring the potential of digital technologies and are interested in using
          them in order to enhance pedagogical and professional practice. You have tried using digital
          technologies in some areas and will benefit from more consistent use. You can increase your
          competence by using digital technologies in various contexts and for a range of purposes,
          integrating them into many of your practices. This will move you to the next step of digital
          competence, the Integrator level.
        </div>
      </div>
      <div>
        <h3>Integrator (B1)</h3>
        <div style={{ marginBottom: "20px" }}>
          You experiment with digital technologies in a variety of contexts and for a range of purposes,
          integrating them into your practices. You creatively use them to enhance diverse aspects of
          your professional engagement. You are eager to expand your repertoire of practices. You will
          benefit by increasing your understanding about which tools work best in which situations and on
          fitting digital technologies to pedagogic strategies and methods. Try to give yourself some
          more time for reflection and adaptation, complemented by collaborative encouragement and
          knowledge exchange, to reach the next step, Expert.
        </div>
      </div>
      <div>
        <h3>Expert (B2)</h3>
        <div style={{ marginBottom: "20px" }}>
          You use a range of digital technologies confidently, creatively and critically to enhance your
          professional activities. You purposefully select digital technologies for particular
          situations, and try to understand the benefits and drawbacks of different digital strategies.
          You are curious and open to new ideas, knowing that there are many things you have not tried
          out yet. You use experimentation and reflection as a means of redesigning, expanding,
          structuring and consolidating your repertoire of strategies. Share your expertise with other
          teachers and continue critically developing your digital strategies to reach the Leader level.
        </div>
      </div>
      <div>
        <h3>Leader (C1)</h3>
        <div style={{ marginBottom: "20px" }}>
          You have a consistent and comprehensive approach to using digital technologies to enhance
          pedagogic and professional practices. You rely on a broad repertoire of digital strategies from
          which you know how to choose the most appropriate for any given situation. You continuously
          reflect on and further develop your practices. Exchanging with peers, you keep updated on new
          developments and ideas and help other teachers seize the potential of digital technologies for
          enhancing teaching and learning. If you are ready to experiment a bit more, engaging students
          in expanding the potential of digital technologies at school level and beyond, you’ll be able
          to reach an ultimate stage of competence, as a Pioneer.
        </div>
      </div>
      <div>
        <h3>Pioneer (C2)</h3>
        <div style={{ marginBottom: "20px" }}>
          You critically reflect on the adequacy of contemporary digital and pedagogical practices, in
          which you are a Leader. You are concerned about the constraints or drawbacks of these practices
          and driven by the impulse to innovate education even further. You experiment with highly
          innovative and complex digital technologies and/or develop novel pedagogical approaches. You
          lead innovation in your school and are a role model for other teachers. You expand your
          practices beyond the school community and engage stakeholders for further developments.
          Continue to be open to new ideas and keep up with the continuous technological and pedagogical
          advances to enhance your creative and innovative solutions.
        </div>
      </div>
      <div>
        <h3>Digital Uninitiated (D1)</h3>
        <div style={{ marginBottom: "20px" }}>
          You are at the very beginning of your digital journey in education. Perhaps the vast world of
          digital tools and techniques feels unfamiliar and a tad overwhelming. While you might not have
          explored or employed many (if any) digital strategies in your teaching yet, you possess a
          genuine curiosity and willingness to learn. As you embark on this journey, remember that
          everyone starts somewhere. With the right resources and support, you'll soon find your footing,
          discovering the endless possibilities that digital integration offers to enhance your teaching.
        </div>
      </div>
    </>
  );
}
